module.exports = __webpack_public_path__ + "static/media/pink_upward_arrowd27c6aad845bfb2420f418ee73cdd9c3.webp";